import type { ChatServerEvent } from '@/hooks/useWebSocket';

export function releasesPendingSubmission(event: ChatServerEvent): boolean {
  return (event.type === 'interaction' && Boolean(event.assistantMessage))
    || event.type === 'result'
    || event.type === 'error'
    || event.type === 'provider_connection_required'
    || event.type === 'cancelled'
    || event.type === 'exit';
}
